<template>
  <v-card-text>
    <v-app-bar flat color="white">
      <v-avatar size="42" class="mr-2">
        <img :src="comment.publisher.image" />
      </v-avatar>

      <v-toolbar-title class="subtitle-1 font-weight-bold black--text pl-0">
        {{ comment.publisher.firstName }}
        {{ comment.publisher.lastName }}
        <p class="caption mb-0 grey--text">{{ comment.created_at | moment }}</p>
      </v-toolbar-title></v-app-bar
    >

    <div class="body-2">{{ comment.text }}</div>
    <v-img
      width="150"
      height="150"
      contain
      aspect-ratio="1"
      v-if="comment.image && comment.image.url"
      :src="comment.image.url"
    ></v-img>

    <!-- old -->
    <!-- <v-list-item>
      <v-list-item-avatar class="mr-4">
        <v-img :src="comment.publisher.image" alt="John"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <div class="bubble">
          <v-list-item-title
            >{{ comment.publisher.firstName }}
            {{ comment.publisher.lastName }}</v-list-item-title
          >
          <v-list-item-subtitle>
            {{ comment.text }}
            <lightbox
              v-if="comment.image && comment.image.url"
              class="mt-4"
              :items="[comment.image.url]"
              :cell="1"
              style="height: 100px; width: 100%"
            ></lightbox>
          </v-list-item-subtitle>
        </div>
        <div class="summary">
          <div class="v-list-item__subtitle">
            {{ comment.created_at | moment }}
          </div>
          <v-btn
            x-small
            elevation="0"
            text
            :color="'pink'"
            v-if="liked"
            @click="unLikeComment()"
          >
            <v-icon x-small class="mr-1">{{ "fas fa-heart" }}</v-icon>
            {{ comment.totalLiked || "" }}
          </v-btn>
          <v-btn
            x-small
            elevation="0"
            text
            v-if="!liked"
            @click="likeComment()"
          >
            <v-icon x-small class="mr-1">{{ "far fa-heart" }}</v-icon>
            {{ comment.totalLiked || "" }}
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item> -->
  </v-card-text>
</template>
<script>
import moment from "moment";
import Vue from "vue";
export default {
  props: ["comment", "postId"],
  data: () => ({
    // url: "https://api.nerdof.com/api",
    liked: false,
  }),
  mounted() {
    this.liked = this.comment.liked;
  },
  filters: {
    moment: function (date) {
      return moment(date).format("D MMMM YYYY, HH:mm:ss");
    },
  },
  methods: {
    likeComment() {
      Vue.axios
        .post(
          `${this.$store.state.api}/postcomment/like`,
          {
            idpost: this.postId,
            idcomment: this.comment._id,
          },
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.updateItem(res);
          this.comment.totalLiked++;
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    unLikeComment() {
      Vue.axios
        .post(
          `${this.$store.state.api}/postcomment/unlike`,
          {
            idpost: this.postId,
            idcomment: this.comment._id,
          },
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.updateItem(res);
          if (this.comment.totalLiked - 1 >= 0) {
            this.comment.totalLiked--;
          }
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    updateItem(res) {
      if (res.data.status) {
        this.comment.liked === res.data.result.liked;
        this.comment.likes === res.data.result.likes;
        this.liked = res.data.result.liked;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item {
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 8px 16px;

  .v-list-item__avatar {
    align-self: flex-start;
  }

  .v-list-item__content {
    padding: 0 !important;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.bubble {
  background: #f1f3f5;
  padding: 10px 12px !important;
  border-radius: 8px;
  max-width: 100%;
  margin-bottom: 4px;
}

.summary {
  display: flex;
  align-items: center;
  padding-left: 12px;

  .v-list-item__subtitle {
    margin-right: 4px;
    font-size: 12px;
    opacity: 0.75;
  }
}
</style>

